var map = {
	"./Dr.B.Priyadharishini.jpg": 58067,
	"./Dr.D.Ramya.jpg": 11881,
	"./Dr.I.Salma.jpeg": 84917,
	"./Dr.J.Rajini.JPG": 82893,
	"./Dr.K.Jefferson.jpg": 82946,
	"./Dr.M.Sakthiradha.JPG": 13259,
	"./Dr.P.V.Rajlakshmi.jpg": 35065,
	"./Dr.R.Aruna.jpg": 80524,
	"./Dr.R.D.Gomathi.JPG": 80951,
	"./Dr.R.Ramya Sri.jpg": 83511,
	"./Dr.S.Gandhimathi.JPG": 88999,
	"./Dr.S.Govarthini.jpeg": 66852,
	"./Dr.S.Yasmin.png": 5001,
	"./Dr.T.Geetha.jpg": 18497,
	"./Mr.R.Thirumalai Rajan.jpg": 26816,
	"./Mr.S.Marimuthu.jpg": 74491,
	"./Mr.S.Prabakaran.jpg": 91636,
	"./Ms.A.Rajalakshmi.jpg": 1315,
	"./Ms.E.M.Sri Amirthavarshini.jpg": 66919,
	"./Ms.J.Latha.jpg": 257,
	"./Ms.M.Kowsika.jpg": 4193,
	"./Ms.S.Janani Sri.jpg": 14875,
	"./Ms.S.Kokila.jpg": 62139,
	"./Ms.S.Shobana.jpg": 85094,
	"./Ms.V.Priyanka.jpg": 88906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89429;